export enum PathNames {
  home = "/",
  login = "/login",
  error = "/error",
  previewerPDF = "/preview-pdf",
  invest = "/invest",
  questionAnswer = "/question-answer",
}
